/**
 * ## 文件说明
 * - **文件功能**：博客图片 URL 规整工具——把数据库中的历史绝对链接
 *   （http://任意IP:任意端口/blog/download/xxx.png）与新版相对链接
 *   （/uploads/xxx.png）统一规整为同域相对路径，供 <img>/Image 直接渲染；
 *   避免后端端口变更（9090→9091）或 IP 变更导致历史图片全部失效
 * - **输入参数**：无（由各组件导入使用）
 * - **输出参数**：无
 * - **返回值**：无（导出工具函数）
 */

/**
 * ### 函数功能
 * - 功能：规整博客图片 URL——支持三种形态：
 *   1. /uploads/xxx.png（新版相对链接，原样返回）
 *   2. http://ip:port/blog/download/xxx.png（旧版绝对链接，取文件名部分
 *      拼为 /uploads/xxx.png，由 nginx 静态映射提供服务）
 *   3. 其他（空值/外链等）原样返回
 * - 输入参数：url - 数据库中存储的图片地址
 * - 输出参数：无
 * - 返回值：string - 可直接用于 <img src> 的同域相对路径
 */
export function normalizeImageUrl(url: string | null | undefined): string {
  if (!url) {
    return ''
  }
  const trimmed = url.trim()
  if (!trimmed) {
    return ''
  }
  // 新版相对链接直接使用
  if (trimmed.startsWith('/uploads/')) {
    return trimmed
  }
  // 旧版绝对链接：取文件名部分重新拼接（兼容任意历史 IP/端口）
  const match = trimmed.match(/\/blog\/download\/([^/?#]+)/)
  if (match) {
    return `/uploads/${match[1]}`
  }
  return trimmed
}
